<!--<sub>Text-setting</sub>-->
<div >
  {{line.variable.text}}
  <app-unit [unit]="line.variable.unit"></app-unit>
    {{ GetText(itemValue) }}
  <small>(  {{itemValue.val}} ) </small>
  <app-unit [unit]="line.variable.unit"></app-unit>
</div>






